import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import Toggle from '../../commonComponents/util/Toggle';
import NumberFormat from 'react-number-format';
import AddressAutocomplete from '../../commonComponents/shared/AddressAutocomplete';
import { deepEquals, toTitleCase, validateFieldLength } from '../../../lib/utils';
import { RecipientTypes } from '../../../lib/systemVariables';

export default class ThirdPartyPayeeModal extends React.Component {

    initialState = {
        payee: {
            isIsraeli: false,
            firstName: '',
            lastName: '',
            orgName: '',
            address: {},
            bankNumber: '',
            branchNumber: '',
            accountNumber: '',
            accountHolder: ''
        },
        payeeType: RecipientTypes.Individual,
        initialPayee: {},
        dataErrors: [],
        submitAttempted: false
    };

    constructor(props) {
        super(props);

        this.state = this.initialState;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.show && !this.props.show) {
            const payee = { ...this.state.payee, ...nextProps.payee };
            this.setState({
                payee,
                initialPayee: payee,
                payeeType: payee.orgName ? RecipientTypes.Organization : RecipientTypes.Individual,
                recipientIsIsraeli: undefined
            });
        }
    }

    onUpdatePayeeType = (name, value) => {
        const { payee, initialPayee } = this.state;
        if (value === RecipientTypes.Individual) {
            this.setState({
                [name]: value,
                payee: { ...payee, orgName: '', firstName: initialPayee.firstName, lastName: initialPayee.lastName }
            });
        } else if (value === RecipientTypes.Organization) {
            this.setState({
                [name]: value,
                payee: { ...payee, firstName: '', lastName: '', orgName: initialPayee.orgName }
            });
        }
    }

    onChange = (name, value) => {
        if (name === "isIsraeli") {
            this.setState({
                payee: {
                    ...this.state.payee,
                    [name]: value,
                    address: {},
                    bankNumber: '',
                    branchNumber: '',
                    accountNumber: '',
                    accountHolder: ''
                }
            });
        } else {
            if (name === "firstName" || name === "lastName" || name === "orgName") value = toTitleCase(value);

            this.setState({ payee: { ...this.state.payee, [name]: value } });
        }
    }

    onChangeEvt = event => {
        this.onChange(event.target.name, event.target.value);
    }

    onSubmit = async () => {
        this.setState({ submitAttempted: true });

        const payee = this.state.payee;
        if (this.state.dataErrors.length
            || !(this.state.payeeType === RecipientTypes.Organization ? payee.orgName : (payee.firstName && payee.lastName)) //names always required
        ) {
            return;
        }

        await this.props.submitPayee(payee);
        this.onClose();
    }

    onClose = () => {
        this.setState({
            recipientIsIsraeli: this.props.recipientIsIsraeli
            //this property will cause autosuggest input to remount with isIsraeli set to that of the recipient, in order to reload google places script to appropriate value for recipient
        }, () => {
            this.props.close();
            this.setState(this.initialState);
        });
    }

    validateFieldLength = (name, length, value) => {
        const isValid = validateFieldLength(length, value);
        this.setDataError(name, !isValid);
        return isValid;
    }

    setDataError = (errorName, error) => {
        let dataErrors = [...this.state.dataErrors];
        if (error)
            dataErrors.push(errorName);
        else
            dataErrors = dataErrors.filter(e => e !== errorName);
        this.setState({ dataErrors });
    }

    render() {
        const { payee, initialPayee, payeeType, recipientIsIsraeli, dataErrors, submitAttempted } = this.state;
        const { isManualPayment, recipientTypes, useRecipientAddress, show, submitAttempted: applicationSubmitAttempted } = this.props;

        return (
            <Modal modalShowing={show}>
                <div className="modal-container">
                    <div className="modal new-transaction-modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">New Third Party Payee</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose.bind(this)}></i>
                        </div>
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <RadioGroup
                                        options={recipientTypes}
                                        title="Third Party Type"
                                        name="payeeType"
                                        value={payeeType}
                                        onChange={this.onUpdatePayeeType} />
                                </div>
                                <div className="modal-row">
                                    <div className="flex-center">
                                        <Toggle id="thirdPartyIsraeli" name="isIsraeli" value={payee.isIsraeli} onChange={this.onChange} />
                                        <label className="small-text middle">Israeli</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-section">
                            {payeeType === RecipientTypes.Individual
                                ? <div className="modal-row">
                                    <div className="column-half">
                                        <ValidatedInput input={<input type="text" />}
                                            label="First Name" name="firstName" value={payee.firstName} onChange={this.onChange}
                                            required={true} showRequiredError={submitAttempted || applicationSubmitAttempted} />
                                    </div>
                                    <div className="column-half">
                                        <ValidatedInput input={<input type="text" />}
                                            label="Last Name" name="lastName" value={payee.lastName} onChange={this.onChange}
                                            required={true} showRequiredError={submitAttempted || applicationSubmitAttempted} />
                                    </div>
                                </div>
                                : <div className="modal-row">
                                    <div className="column-half">
                                        <ValidatedInput input={<input type="text" />}
                                            label="Name" name="orgName" value={payee.orgName} onChange={this.onChange}
                                            required={true} showRequiredError={submitAttempted || applicationSubmitAttempted} />
                                    </div>
                                </div>}
                        </div>
                        <div className="modal-section">
                            <div className="modal-row">
                                <AddressAutocomplete hide={payee.isIsraeli} //showing address autocomplete if recipient is Israeli to ensure re-load of script when close modal for appropriate val for recipient 
                                    isIsraeli={recipientIsIsraeli !== undefined ? recipientIsIsraeli : false}
                                    required={!isManualPayment && !useRecipientAddress} //not required if manual check or using recipient address
                                    showRequiredError={applicationSubmitAttempted && !recipientIsIsraeli} //not if recipientIsIsraeli - to avoid flashing required style in this case
                                    address={payee.address}
                                    updateAddress={this.onChange.bind(this, 'address')}
                                    updateError={() => this.setDataError('address')}
                                />
                            </div>
                            {payee.isIsraeli && !isManualPayment && //not allowing bank info if manual check
                                <div>
                                    <div className="modal-row">
                                        <div className="column-half">
                                            <ValidatedInput input={<NumberFormat placeholder="##" format="##"
                                                onValueChange={(values) => this.onChange('bankNumber', values.value)} />}
                                                label="Bank Number" name="bankNumber"
                                                value={payee.bankNumber}
                                                required={true}
                                                showRequiredError={applicationSubmitAttempted}
                                                errorMessage="Invalid Bank Number"
                                                validated={true} showValidationError={true}
                                                validate={val => this.validateFieldLength('bankNumber', 2, val)} />
                                        </div>
                                        <div className="column-half">
                                            <ValidatedInput input={<NumberFormat placeholder="###" format="###"
                                                onValueChange={(values) => this.onChange('branchNumber', values.value)} />}
                                                label="Branch Number" name="branchNumber"
                                                value={payee.branchNumber}
                                                required={true}
                                                showRequiredError={applicationSubmitAttempted}
                                                errorMessage="Invalid Branch Number"
                                                validated={true} showValidationError={true}
                                                validate={val => this.validateFieldLength('branchNumber', 2, val)} />
                                        </div>
                                    </div>
                                    <div className="modal-row">
                                        <div className="column-half">
                                            <ValidatedInput input={<NumberFormat placeholder="###############" format="###############"
                                                onValueChange={(values) => this.onChange('accountNumber', values.value)} />}
                                                label="Account Number" name="accountNumber"
                                                value={payee.accountNumber}
                                                required={true}
                                                showRequiredError={applicationSubmitAttempted} />
                                        </div>
                                        <div className="column-half">
                                            <label className="input-label">Account Holder</label>
                                            <input type="text"
                                                name="accountHolder"
                                                value={payee.accountHolder}
                                                onChange={e => this.onChange(e.target.name, e.target.value)} />
                                        </div>
                                    </div>
                                </div>}
                        </div>

                        <div className="modal-btns text-right">
                            <button className="btn btn-accent" onClick={this.onClose.bind(this)}>Cancel</button>
                            <button className="btn btn-primary"
                                disabled={deepEquals(payee, initialPayee) || dataErrors.length}
                                onClick={this.onSubmit}>Submit</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/ThirdPartyPayeeModal.jsx